import * as authRoutines from '../../authRoutines';
import * as ls from '../../../../services/localStorage';
import * as toastRoutines from '../../../../sagas/routines/toastRoutines';
import * as ui_actions from '../../../../redux/ui/actions';
import * as eventsRoutines from '../../../../Containers/Events/eventRoutines'
import * as userRoutines from '../../../../sagas/routines/userRoutines';
import { call, put, take, takeLatest } from 'redux-saga/effects';
import { fetchEventsSaga } from '../../../Events/sagas/events';
import { firebaseAuthenticationSaga } from '../../../../sagas/firebase';
import { push } from 'connected-react-router';
import api from '../../../../services/api/';
import auth from '../../../../services/auth/';
import eventIdFromPath from '../../../../helpers/eventIdFromPath';
import jwt_decode from "jwt-decode";
import * as _ from 'lodash';

export interface EFLoginProps {
    payload:{
        access_token:string,
        expires_at: string,
        user_id: string
    }
}
export function* obtainSupplementaryUserInfoSaga(email: string) {
    try {
        const res = yield call(auth.obtainSupplementaryUserInfo, { email });
        yield put(authRoutines.obtainSupplementaryUserInfo.success(res.data.response[0]));
    } catch (error) {
        yield put(authRoutines.obtainSupplementaryUserInfo.failure(error));
    }
}

export function* commandCenterLoginSaga(action: any) {
    try {

        const res = yield call(api.getMe)

        const data = _.get(res, 'data.response');
        localStorage.setItem('CC_USER_ID', data.id);

        yield put(authRoutines.commandCenterLogin.success(data.id));
        yield put(authRoutines.authenticatedBootstrapping());
        yield put(push('/events'));
    } catch (error) {
        yield put(authRoutines.isAuthenticating(false));
        yield put(toastRoutines.setToastError('Please ensure you have entered the correct credentials.'));
        yield put(authRoutines.commandCenterLogin.failure(error));
    }
}

function* obtainJWTSaga() {
    try {
        const jwtRes = yield call(auth.jwtService); //Logs in to EF
        const { token } = jwtRes.data.response;
        ls.setJWT(token);
        yield put(authRoutines.obtainJWT.success(token));
    } catch (error) {
        yield put(authRoutines.obtainJWT.failure(error));
    }
}

function* authenticatedBootstrapSaga(action: any) {
    //Runs once we are sure we have a valid CC_ACCESS_TOKEN
    let redirect = 'events';
    try {
        yield call(obtainJWTSaga);
        yield call(firebaseAuthenticationSaga, { payload: ls.getJWT() }); //using call instead of PUT so that this is blocking
        yield call(fetchEventsSaga); //Sync/Fetch events from EF

        yield put(ui_actions.setEventsLoaded(true));

        //If "from" path contains an event, let's run the eventwide sagas
        if (action.payload && action.payload.pathname && eventIdFromPath(action.payload.pathname)) {
            const eventId = eventIdFromPath(action.payload.pathname);
            //TODO add logic to call event if it isn't there yet
            redirect = action.payload.pathname;
            yield put(eventsRoutines.fetchEvent(eventId))
            yield put(ui_actions.setActiveEvent(eventId));
            yield take(eventsRoutines.fetchEvent.SUCCESS);
            yield take(ui_actions.bootstrapEvent.SUCCESS);
        }

        yield put(authRoutines.authenticatedBootstrapping.success());
        //So we can show indicator
        yield put(authRoutines.isAuthenticating(false));
        yield put(push(redirect));
    } catch (error) {
        yield put(authRoutines.isAuthenticating(false));
        yield put(toastRoutines.setToastError(error));
        yield put(authRoutines.commandCenterLogout());
    }
}

//TODO convert these into actionCreators
function* checkUserSaga(action: any) {
    try {
        yield call(api.getUser, ls.getCCValues().CC_USER_ID);
        yield put(userRoutines.checkUser.success());
        yield put(authRoutines.authenticatedBootstrapping(action.payload));
    } catch (error) {
        yield put(userRoutines.checkUser.failure(error));
        yield put(push('/login'));
    }
}

function* commandCenterLogoutSaga(payload: any) {
    try {
        ls.clearCCValues(); //Wipes localStorage of EF_ values
        localStorage.setItem('persist:root', '');
        yield put(ui_actions.setEventsLoaded(false));

        yield put(authRoutines.firebaseSignout());
        yield put(authRoutines.commandCenterLogout.success());
    } catch (error) {
        yield put(authRoutines.commandCenterLogout.failure(error));
    }
}

export default function* watchUserAuthentication() {
    yield takeLatest(authRoutines.authenticatedBootstrapping.TRIGGER, authenticatedBootstrapSaga);
    yield takeLatest(authRoutines.commandCenterLogin.TRIGGER, commandCenterLoginSaga);
    yield takeLatest(authRoutines.commandCenterLogout.TRIGGER, commandCenterLogoutSaga);
    yield takeLatest(authRoutines.obtainSupplementaryUserInfo.TRIGGER, obtainSupplementaryUserInfoSaga);
    yield takeLatest(userRoutines.checkUser.TRIGGER, checkUserSaga);
}
